export interface IReportRequest {
  startDate?: string;
  endDate?: string;
  workspaceId?: string[];
  ticketWorkspaceIds?: string[];
  ticketServiceIds?: string[];
  ticketChannelIds?: string[];
  userIds?: string[];
  automationCode?: string[];
  automationCodeExcept?: string[];
  establishmentId?: string[];
  esignRuleId?: string[];
}

export enum ReportColumnType {
  Text = 1,
  Number = 2,
  Date = 3,
  DateTime = 4,
  Currency = 5,
  Percentage = 6,
  Boolean = 7,
}

export enum ReportPeriodicity {
  Default = 0,
  Daily = 1,
  Monthly = 2,
}

export interface IReportColumn {
  key: string;
  label: string;
  type: ReportColumnType | string;
  align?: string | null;
  format?: string | null;
  isTotalizable?: boolean | null;
}

export interface IReportRow {
  isTotal: boolean;
  values: Record<string, unknown>;
}

export interface IReportGroupHeaderField {
  key: string;
  label?: string | null;
  format?: string | null;
}

export interface IReportGrouping {
  key: string;
  label?: string | null;
  headerFields?: IReportGroupHeaderField[] | null;
  showGroupTotals?: boolean | null;
  showGrandTotal?: boolean | null;
}

export interface IReportResult {
  title?: string | null;
  periodicity?: ReportPeriodicity | string | null;
  columns: IReportColumn[];
  rows: IReportRow[];
  grouping?: IReportGrouping | null;
}
